import functions from "./functions";


function registerNewsletter(){
    if (functions.checkPage('page-template-register')) {
        let newsletterCheckbox = document.querySelector('[data-newsletter]');
        newsletterCheckbox.addEventListener('change', () => {
            let newsletterItemsContainer = document.querySelector('[data-register-newsletter]');
            newsletterItemsContainer.classList.toggle('show-animals');
        });
    }
}

export default {registerNewsletter};


// WEBPACK FOOTER //
// ./src/scripts/register.js